import React from 'react'
import humanFormat from 'human-format'
import { PoolInfo } from 'src/services/CurveService'
import { formatBigNumber } from 'src/utils/format/formatBigNumber'
import { InfoBox } from '../InfoBox'

interface IProps {
  poolInfo: PoolInfo
}

export function SwapInfo({ poolInfo }: IProps) {
  return (
    <InfoBox
      infos={[
        {
          property: 'Total Deposited',
          value: `$${
            poolInfo ? humanFormat(Number(formatBigNumber(poolInfo.totalLiquidity))) : '?'
          }`,
          tooltip: 'Amount of total deposited tokens in the pool',
        },
        {
          property: 'STABLEx Deposited',
          value: `$${
            poolInfo ? humanFormat(Number(formatBigNumber(poolInfo.tokenDeposited))) : '?'
          }`,
          tooltip: 'Amount of STABLEX deposited in the pool',
        },
        {
          property: '3Pool Deposited',
          value: `$${
            poolInfo ? humanFormat(Number(formatBigNumber(poolInfo.threePoolDeposited))) : '?'
          }`,
          tooltip: 'Amount of DAI+USDC+USDT tokens deposited in the pool',
        },
        {
          property: 'Max Slippage',
          value: '2%',
          tooltip: 'Max difference between expected and returned amount of target token',
        },
      ]}
    />
  )
}
